export const Divider = () => {
  return (
    <hr
      css={{ height: 1, margin: '10px -10px', borderWidth: 0, backgroundColor: 'rgba(255, 255, 255, 0.2)' }}
    />
  )
}
